/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const TestEventResponse = zod
	.object({
		event_id: zod.string().describe('ID of the created test event'),
		message: zod.string().describe('Success message')
	})
	.describe('Response after sending a test event');

export type TestEventResponse = zod.input<typeof TestEventResponse>;
export type TestEventResponseOutput = zod.output<typeof TestEventResponse>;
